import React from 'react';

import { Placeholder } from './placeholder';

export const Value = ({
  children,
  ...props
}: {
  children: React.ReactNode;
}) => (
  <>
    <div className="Placeholder Value">
      <Placeholder paragraph={false} {...props}>
        {children}
      </Placeholder>
    </div>
    <style jsx>{`
      .Placeholder.Value :global(.ant-skeleton .ant-skeleton-title) {
        margin-top: 4px;
        margin-bottom: 0px;
      }
    `}</style>
  </>
);

Value.defaultProps = {};
